import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { UserStorageService } from '../services/user-storage.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard {

    constructor(
      private authenticationService: AuthenticationService,
      private userStorageService: UserStorageService,
      private router: Router) {}

      canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Observable<boolean> {
        return this.authenticationService.isLoggedIn
          .pipe(
            take(1),
            map((isLoggedIn: boolean) => {
              const currentUserSession = this.userStorageService.currentUserSession;
              if (!isLoggedIn || !currentUserSession) {
                this.router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url }});  // {4}
                return false;
              }

              if (next.data.roles && next.data.roles.indexOf(currentUserSession.user.role) === -1) {
                  // role not authorised so redirect to home page
                  this.router.navigate(['/']);
                  return false;
              }

              return true;
            }));
      }
}
